import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Chart, ChartCallbackFunction } from 'highcharts';
import * as Highcharts from 'highcharts';
import { default as HC_More } from 'highcharts/highcharts-more';
import { default as HC_No_Data } from 'highcharts/modules/no-data-to-display';
import { default as HC_Histogram_Bellcurve } from 'highcharts/modules/histogram-bellcurve';
import { default as HC_Solid_Gauge } from 'highcharts/modules/solid-gauge';
import { default as HC_Word_Cloud } from 'highcharts/modules/wordcloud';
import {default as HeatmapModule} from 'highcharts/modules/heatmap';
import { highchatsTheme } from './highcharts-config/highcharts-theme';
import { ThemesService } from '@projects/shared/src/app/features/setting/services/themes.service';

 @Component({
  selector: 'base-highchart',
  templateUrl: './base-highchart.component.html',
  styleUrls: ['./base-highchart.component.scss'],
})
export class BaseHighchartComponent implements OnInit {
  @Input() className: string = '';
  @Input() configuration: any;
  @Input() style: any;
  @Input() solidGauge = false;
  @Input() histogramBellcurve = false;

  @Output() getChartRef = new EventEmitter<Chart>();

  chartRef: Chart | any;
  updateFlag: any;

  Highcharts: typeof Highcharts = Highcharts;

  constructor(themeService: ThemesService) {
    HC_More(Highcharts);
    HC_No_Data(Highcharts);
    HC_Solid_Gauge(Highcharts);
    HC_Word_Cloud(Highcharts);
    HeatmapModule(Highcharts);
    highchatsTheme(themeService.getWidgetColors(), themeService.getWidgetLabelColor());
  }

  ngOnInit(): void {
    if (this.histogramBellcurve) HC_Histogram_Bellcurve(Highcharts);
  }

  reflowChart(): void {
    this.chartRef.reflow();
  }

  callbackFunction: ChartCallbackFunction = (chart) => {
    this.chartRef = chart;
    this.getChartRef.emit(this.chartRef);
  };
}
